import { useMarketMode } from "../marketMode";
import useCheckAddressForExpressMutation from "../shippingZones/useGetCheckAddressForExpress";
import { useActiveOrMainShippingZone } from "../shippingZones";
import { LocationAddress } from "@core/types";
import { useCartData } from "../cartDataStore";

/**
 * useExpressDeliveryCheck is a hook that checks if the express delivery is available for the given address
 * and sets the mode to express if it is available
 * @returns {checkAndSetExpressMode} - a function that checks if the express delivery is available for the given address
 * and sets the mode to express if it is available
*/
const useExpressDeliveryCheck = () => {
  const { getProductsTotalWeight } = useCartData();
  const totalWeight = getProductsTotalWeight();
  const { mode, toggleMode } = useMarketMode();
  const { mutateAsync: checkAddressForExpress } = useCheckAddressForExpressMutation();
  const { activeShippingZone } = useActiveOrMainShippingZone();

  const checkAndSetExpressMode = async ({ latitude, longitude }: LocationAddress) => {
    if (latitude && longitude) {
      try {
        const data = await checkAddressForExpress({
          latitude,
          longitude,
          totalWeight,
        });
        toggleMode(data.expressPoints.length > 0 ? "express" : "market", activeShippingZone?.id || "");

        if (data.expressPoints.length) {
          if (mode === "market") {
            toggleMode("express", activeShippingZone?.id || "");
          }
        }
      } catch (error) {
        console.error("Error checking express delivery:", error);
        // Fallback to market mode in case of an error
        toggleMode("market", activeShippingZone?.id || "");
      }
    } else {
      toggleMode("market", activeShippingZone?.id || "");
    }
  };

  return { checkAndSetExpressMode };
};

export default useExpressDeliveryCheck;
